"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooltipIcon = void 0;
const HelpIcon_1 = __importDefault(require("@opsbase/web-icons/icons/HelpIcon"));
const react_1 = __importDefault(require("react"));
const Tooltip_1 = __importDefault(require("../Tooltip"));
function TooltipIcon(props) {
    const { tip, style } = props;
    return (react_1.default.createElement(Tooltip_1.default, { arrow: true, style: Object.assign({}, style), transparent: false, placement: 'bottom', tip: react_1.default.createElement("div", { style: { padding: 5 } }, tip) },
        react_1.default.createElement(HelpIcon_1.default, { size: 14 })));
}
exports.TooltipIcon = TooltipIcon;
exports.default = TooltipIcon;
